<template>
  <button
    type="{{ type }}"
    @click="action"
    :disabled="disabled"
    class="button"
  >
    {{ label }}
  </button>
</template>

<style scoped>
  .button {
    display: block;
    width: 100%;
    height: 50px;
    margin-top: 20px;
    padding: 10px 20px;
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--primary-text-color-white);
    background-color: var(--primary-color);
    border: none;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.2s;
  }

  .button:hover,
  .button:focus,
  .button:active {
    background-color: var(--secondary-color);
  }
</style>

<script>
  export default {
    props: [
      'type',
      'label',
      'action',
      'disabled'
    ]
  }
</script>
